import picsioConfig from '../../../../../../config';
import isToriutTrialExpired from './isToriutTrialExpired';

/**
 * PCS-11271: true when this client must behave as hard-locked, i.e. the server's
 * `ensureToriutTrialAccess` middleware is going to answer 403 to every JSON/XHR
 * call outside its small allowlist.
 *
 * Callers use it to skip requests that are guaranteed to fail (a doomed request
 * surfaces as an error dialog/toast on top of the trial-expired flow). Keep the
 * three conditions together here: gating on `toriutAccessState` alone would also
 * suppress requests on Pics.io or while the kill-switch is off, when the server
 * is in fact still serving them.
 */
const isToriutTrialLocked = (user) => Boolean(
  picsioConfig.isPim
  && picsioConfig.toriutTrial?.enforcementEnabled !== false
  && isToriutTrialExpired(user),
);

export default isToriutTrialLocked;
